function Down({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.59 0.295044L6 4.87504L1.41 0.295044L0 1.70504L6 7.70504L12 1.70504L10.59 0.295044Z" fill=${`"${col}"`}/>
  </svg>

  `;

  return baseXml;
}

export default Down;
